import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import { clickBaseEvent, viewBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from '../../rio';
import { HeaderContext, isNavLinkItem } from '../../shared';
import { useAccordion, useElementRectInfo, generateRioEventNavText } from '../../shared';
import { CenterNavList, CenterNavListItem, getScrollTop } from '../../styles/mobile';
import { TopLevelNavLink } from '../../styles/mobileAccordion';
import { VisuallyHidden } from '../../styles/root';
import { MenuItemsList, MultiMenu } from '../shared';
import MobileAccordion from './mobileAccordion';

var CenterNav = function CenterNav(_ref) {
  var navLinks = _ref.navLinks,
      activeLink = _ref.activeLink,
      hamburgerMenuRef = _ref.hamburgerMenuRef;

  var _useContext = useContext(HeaderContext),
      envUrl = _useContext.envUrl,
      dataTestPrefix = _useContext.dataTestPrefix;

  var _useAccordion = useAccordion(navLinks, activeLink),
      accordionState = _useAccordion.state,
      dispatch = _useAccordion.dispatch;

  var openIndex = accordionState.openIndex;
  return /*#__PURE__*/React.createElement("nav", {
    role: "navigation",
    "aria-label": "main",
    "data-test": "".concat(dataTestPrefix, "-center-nav")
  }, /*#__PURE__*/React.createElement(CenterNavList, {
    "data-test": "".concat(dataTestPrefix, "-center-nav-list")
  }, navLinks.map(function (navItem, index) {
    var isActiveNavItem = !(activeLink !== null && activeLink !== void 0 && activeLink.child) && (activeLink === null || activeLink === void 0 ? void 0 : activeLink.parent) === (isNavLinkItem(navItem) ? navItem.text : navItem.parent.text);

    var _useElementRectInfo = useElementRectInfo(),
        rectInfo = _useElementRectInfo.rectInfo,
        elementRef = _useElementRectInfo.elementRef;

    return /*#__PURE__*/React.createElement(CenterNavListItem, {
      key: index,
      "data-test": "".concat(dataTestPrefix, "-center-nav-list-item-").concat(index),
      isActive: isActiveNavItem,
      ref: elementRef,
      positionX: rectInfo === null || rectInfo === void 0 ? void 0 : rectInfo.x
    }, isNavLinkItem(navItem) ? /*#__PURE__*/React.createElement(TopLevelNavLink, {
      href: navItem.useAbsolute ? navItem.href : envUrl + navItem.href,
      onClick:
      /* istanbul ignore next */
      function onClick(e) {
        var _navItem$onClick;

        rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
          data: {
            interaction: {
              element: {
                name: 'nav shortcut',
                type: 'link',
                region_name: 'side nav',
                text: navItem.text,
                value: navItem.text.toLowerCase()
              },
              type: 'select'
            }
          }
        }));
        (_navItem$onClick = navItem.onClick) === null || _navItem$onClick === void 0 ? void 0 : _navItem$onClick.call(navItem, e);
      },
      target: navItem.target,
      "data-test": "".concat(dataTestPrefix, "-center-nav-link-").concat(index)
    }, isActiveNavItem && /*#__PURE__*/React.createElement(VisuallyHidden, null, "Current page: "), navItem.text) : /*#__PURE__*/React.createElement(MobileAccordion, {
      head: navItem.parent,
      index: index,
      "data-test": "".concat(dataTestPrefix, "-center-nav-accordion-").concat(index),
      panel: isNavLinkItem(navItem.children[0]) ? /*#__PURE__*/React.createElement(MenuItemsList, {
        listIndex: index,
        itemsList: navItem.children,
        activeItem: activeLink === null || activeLink === void 0 ? void 0 : activeLink.child,
        breadcrumbs: [navItem.parent.text],
        isMobile: true
      }) : /*#__PURE__*/React.createElement(MultiMenu, {
        multiMenuIndex: index,
        menuItems: navItem.children,
        activeItem: activeLink === null || activeLink === void 0 ? void 0 : activeLink.child,
        breadcrumbs: [navItem.parent.text],
        isMobile: true
      }),
      onClickTab:
      /* istanbul ignore next */
      function onClickTab() {
        // Rio - Event; Start
        rioClient.sendEvent(_objectSpread(_objectSpread({}, viewBaseEvent), {}, {
          data: {
            component_view: {
              component: {
                name: 'nav menu',
                type: 'drop down',
                region_name: "top nav|".concat(navItem.parent.text),
                text: generateRioEventNavText(navItem.children)
              },
              state: 'expanded'
            }
          }
        })); // Rio - Event; Finish

        dispatch({
          type: 'update',
          data: {
            index: index
          }
        });

        if (hamburgerMenuRef) {
          setTimeout(function () {
            var _hamburgerMenuRef$cur;

            (_hamburgerMenuRef$cur = hamburgerMenuRef.current) === null || _hamburgerMenuRef$cur === void 0 ? void 0 : _hamburgerMenuRef$cur.scroll({
              behavior: 'smooth',
              top: getScrollTop(index)
            });
          });
        }
      },
      isOpen: openIndex === index,
      isActive: isActiveNavItem
    }));
  })));
};

CenterNav.displayName = 'MobileCenterNav';
export default CenterNav;